import SectionContainer from '@/app/components/SectionContainer/SectionContainer';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { useAnalytics } from '@/app/utils/useAnalytics';
import Image from 'next/image';

import Button from '@material-ui/core/Button';

import styles from './DigitalSolutionsSection.module.scss';
import img1 from './assets/digital-solutions-1.png';
import img2 from './assets/digital-solutions-2.png';
import img3 from './assets/digital-solutions-3.png';
import img4 from './assets/digital-solutions-4.png';

const digitalSolutions = [
  {
    title: 'Create your profile',
    text: 'Register and build your Digital Doctor Profile to match with roles tailored to your skills and preferences quickly.',
    image: img1,
  },
  {
    title: 'Meet your recruiter',
    text: 'You’ll be matched with your dedicated recruiter who is an expert in your grade and specialty.',
    image: img2,
  },
  {
    title: 'Share your goals',
    text: 'They’ll find the right jobs and negotiate top rates to fit your career and lifestyle needs.',
    image: img3,
  },
  {
    title: 'Leave the logistics to us',
    text: 'We’ll handle travel, admin, and paperwork so you can focus on your career.',
    image: img4,
  },
];

export const DigitalSolutionsSection = () => {
  const track = useAnalytics();
  const profileUrl = appClientConfig.practitionerProfileUrl ?? '';
  return (
    <SectionContainer className={styles.container}>
      <h2 className={styles.sectionTitle}>
        Finding your next job <span>just got easier</span>
      </h2>
      <div className={styles.itemsContainer}>
        {digitalSolutions.map(({ image, title, text }) => (
          <div key={title} className={styles.solutionItem}>
            <Image
              src={image}
              priority={false}
              alt=""
              aria-hidden
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
            <div>
              <p className={styles.solutionTitle}>{title}</p>
              <p className={styles.solutionText}>{text}</p>
            </div>
          </div>
        ))}
      </div>
      <Button
        variant="contained"
        className={styles.registerButton}
        href={`${profileUrl}/sign-up`}
        onClick={() =>
          track('Click', {
            action: `Digital solutions section - Register`,
            'element text': 'Register now',
            'element type': 'button',
          })
        }
      >
        Register now
      </Button>
    </SectionContainer>
  );
};
